import { useEffect, useRef } from "react";

interface TextEditorProps {
  value: string;
  onChange: (value: string) => void;
  focusOnMount?: boolean;
}

/**
 * Auto-resizing textarea for editing plain text and markdown cells.
 */
export function TextEditor({ value, onChange, focusOnMount = false }: TextEditorProps) {
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (!focusOnMount) {
      return;
    }

    const el = ref.current;
    if (!el) {
      return;
    }
    el.focus();
    el.setSelectionRange(el.value.length, el.value.length);
  }, [focusOnMount]);

  return (
    <textarea
      ref={ref}
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder="Type something…"
      spellCheck={false}
      className="h-full min-h-0 w-full resize-none overflow-y-auto rounded-lg border border-border/40 bg-muted/10 px-4 py-3 text-[15px] leading-relaxed text-foreground shadow-sm transition-colors placeholder:text-muted-foreground/40 focus:border-primary/40 focus:outline-none focus:ring-1 focus:ring-primary/20"
    />
  );
}
